<template>
  <div class="login_box">
    <div class="left_box">
      <RegisterAndLoginBackImage :show="false" :imgPath="require('../../../assets/newImage/bg_3.jpg')" />
    </div>
    <div class="right_box">
      <Crumbs :showToLogin="false" :pathName="$t('login.login')" />
      <div class="login_info">
        <img src="../../../assets/newImage/logo_5.png" style="margin-bottom:60px;width: 100%;object-fit: cover">
        <!-- 用户名登录 -->
        <LoginByName v-show="loginByname" />
        <!-- 验证码登录 -->
        <LoginByVerifyCode v-show="!loginByname" />
        <div class="bottom_box">
          <div @click="loginByname = !loginByname" v-if="loginByname">
            <img src="../../../assets/newImage/shouji.png" class="login_icon">
            <span>{{ $t('login.verify_login') }}</span>
          </div>
          <div @click="loginByname = !loginByname" v-else>
            <img src="../../../assets/newImage/yaoshi.png" class="login_icon">
            <span>{{ $t('login.code_login') }}</span>
          </div>
          <!-- 占位 -->
          <div></div>
          <!-- <div>{{ $t('login.forgot_password') }}</div> -->
        </div>
        <div style="text-align: center;margin-top: 60px;font-size: 15px;user-select: none;">
          <span style="color: #1e50f0;cursor: pointer;" @click="$router.push('/Register')">{{
            $t('login.register_now')
          }}</span>
          {{ $t('login.get_hotels') }}
        </div>
      </div>

      <footerInfo style="position: absolute;bottom: 1px;left: 0;right: 0;" />
    </div>
  </div>
</template>

<script>
import RegisterAndLoginBackImage from './components/RegisterAndLoginBackImage.vue'
import Crumbs from './components/Crumbs.vue'
import LoginByName from '@/pages/newPages/login/components/LoginByName'
import LoginByVerifyCode from '@/pages/newPages/login/components/LoginByVerifyCode'
import footerInfo from '../frame/footerInfo.vue'
export default {
  data () {
    return {
      loginByname: true
    }
  },
  components: {
    RegisterAndLoginBackImage,
    Crumbs,
    LoginByName,
    LoginByVerifyCode,
    footerInfo
  },
  created () {
    this.checkToken()
  },
  methods: {
    // 免登录
    async checkToken () {
      let partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
      if (partnerInfo) {
        const { data: result } = await this.$http.get('/mini/checkToken', {
          headers: {
            accessToken: partnerInfo.token
          }
        })
        if (result.code == 200) {
          this.$router.replace('/NewHome')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_box {
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-columns: 500px 1fr;

  .right_box {
    padding: 20px;
    position: relative;
  }

  .login_info {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 388px;

    .bottom_box {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      font-size: 13px;
      user-select: none;
      cursor: pointer;

      .login_icon {
        position: relative;
        top: -2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/login/login.vue